import { render, staticRenderFns } from "./workExperience.vue?vue&type=template&id=4ef703b5&scoped=true"
import script from "./workExperience.vue?vue&type=script&lang=js"
export * from "./workExperience.vue?vue&type=script&lang=js"
import style0 from "./workExperience.vue?vue&type=style&index=0&id=4ef703b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef703b5",
  null
  
)

export default component.exports